import { Button } from "antd";
import MultipleSelect from "../inputs/MultipleSelect";
import TextInput from "../inputs/TextInput";
import AddElementLayout from "../layouts/AddElementLayout";
import * as Yup from 'yup';
import SelectInput from "../inputs/SelectInput";
import { useEffect, useState } from "react";
import { getData, postData, updateData } from "../../helpers/api";
import { openNotification } from "../../helpers/alerts";
import { getLocalStorage } from "../../helpers/localstorage";
import { rolesConst } from "../../constants/others";

const AddSubordinated = (props) => {
    const [assignedUsers, setAssignedUsers] = useState([])
    const [managers, setManagers] = useState([])
    const user = getLocalStorage("auth")?.user

    const {
        handleAfterAddingSubordinated,
        initialValue,
        isModalOpen,
        handleCancel
    } = props
    console.log(initialValue)
    const getSubordinated = async () => {
        try {
            const res = await getData("/users/assigned-users")
            console.log(res.data)
            let dataUsers = res.data.map((user) => ({ value: user.id, label: user.name }))
            if(user?.role ===rolesConst.Management){
                dataUsers = dataUsers.filter((el)=> el.user.role !== rolesConst.Management);
            }
            setAssignedUsers(dataUsers)
        } catch (error) {
            console.log(error)
        }
    }


    const getFallowAndManagementUsers = async () => {
        try {
            const res = await getData("users/roles/fallow/management")
            setManagers(res.data.map((ele) => ({ value: ele.id, label: ele.name })))
        } catch (error) {
            console.log(error)
        }
    }


    useEffect(() => {
        getSubordinated()
        getFallowAndManagementUsers()
    }, [])


    const addSubordinated = async (values, submitProps) => {
        try {
            if (initialValue.add) {
                await postData("/subordinated", values)
                openNotification(`Le subordonné a été ajouter avec succès`, 'success')
            } else {
                await updateData(`/subordinated/${initialValue.subordinatedId}/manager/${values.managerId}`);
                openNotification(`Le subordonné a été mis a jour avec succès`, 'success')
            }

            submitProps.resetForm()
            handleAfterAddingSubordinated()
        } catch (error) {
            openNotification(`Erreurs côté serveur`, 'error')
        }
    }
    return (
        <AddElementLayout
            title={initialValue.edit ? `Mis a jour le Subordonné ${initialValue.subordinatedName}` : "Ajouter un Subordonné"}
            isModalOpen={isModalOpen}
            handleCancel={handleCancel}
            initialValue={initialValue}
            validationSchema={Yup.object({
                managerId: Yup.number().required('required'),
                subordinatedId: Yup.number().required('required'),
            })}
            handleSubmitForm={(values, submitProps) => {
                addSubordinated(values, submitProps)
            }}
        >
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 10
                }}
            >
                <SelectInput
                    name="managerId"
                    size="large"
                    placeholder="Responsable"
                    options={managers}
                />
                {initialValue.add && <SelectInput
                    name="subordinatedId"
                    size="large"
                    placeholder="Subordonnés"
                    options={assignedUsers}
                />}
                <Button
                    size='large'
                    type="primary"
                    htmlType="submit"
                >
                    {initialValue.edit ? "Mis a jour" : "Ajouter"}
                </Button>
            </div>
        </AddElementLayout>
    );
}

export default AddSubordinated;